import React from 'react'
import { useIntl } from 'react-intl'
import { Box, Container, Typography } from '@mui/material';

import { withStyles } from '@mui/styles'

import { PORequestsFilter, PORequestsTable } from '../../../../features/po-requests'
import { useCombos } from '../../../../features/combos'
import { PO_REQUESTS_COMBOS_IDS } from '../../constants'
import { poRequestsDashboardStyles } from './po-requests-dashboard.styles'

export const PORequestsDashboardPage = withStyles(poRequestsDashboardStyles)(({ classes }) => {
  useCombos(PO_REQUESTS_COMBOS_IDS)
  const { formatMessage } = useIntl()

  return (
    <Container className={classes.container} maxWidth="xl">
      <Box mb={2}>
        <Typography variant="h4" color="textSecondary">
          {formatMessage({ id: 'pages.poRequests.dashboard.title' })}
        </Typography>
      </Box>
      <Box mb={2} display="flex">
        <PORequestsFilter />
      </Box>
      <Box>
        <PORequestsTable />
      </Box>
    </Container>
  )
})
